module.exports = "../dist/img/img_2-31.422d.jpg";